import { render } from "./OmnichannelOverviewSankey.vue?vue&type=template&id=3b879efd&scoped=true"
import script from "./OmnichannelOverviewSankey.vue?vue&type=script&lang=js"
export * from "./OmnichannelOverviewSankey.vue?vue&type=script&lang=js"

import "./OmnichannelOverviewSankey.vue?vue&type=style&index=0&id=3b879efd&lang=scss"
import "./OmnichannelOverviewSankey.vue?vue&type=style&index=1&id=3b879efd&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b879efd"]])

export default __exports__